export default class Cookie {
    public static keys: Record<string, string> = {
        IS_COMPACT: 'isCompact',
        IS_DARK_MODE: 'isDarkMode',
        PRODUCT_CURRENCY: 'productCurrency',
        PROJECT_MANAGER_FOLDER_TREE_EXPANDED_KEYS: 'projectManagerFolderTreeExpandedKeys',
        PROJECT_MANAGER_HIDE_CLOSED: 'projectManagerHideClosed',
        PROJECT_MANAGER_HIDE_NON_FAVOURITE: 'projectManagerHideNonFavourite',
        PROJECT_MANAGER_IS_COMPACT_VIEW: 'projectManagerIsCompactView',
        PROJECT_MANAGER_SORT_ASCENDING: 'projectManagerSortAscending',
        PROJECT_MANAGER_SORT_COLUMN: 'projectManagerSortColumn',
        PROJECT_MANAGER_VIEW: 'projectManagerView',
        RELATIONSHIP_COLUMNS: 'relationshipColumns',
        RELATIONSHIP_VIEW: 'relationshipView',
        SCHEDULE_DIALOG_MAXIMISED: 'scheduleDialogMaximised',
        SCHEDULE_GRID_SIZE: 'scheduleGridSize',
        SCHEDULE_PERFORMANCE_WARNING_BYPASSED: 'schedulePerformanceWarningBypassed',
        SCHEDULE_SECTION_ACTIVITY_PINNED: 'scheduleSectionActivityPinned',
        SCHEDULE_SECTION_ACTIVITY_VERTICAL: 'scheduleSectionActivityVertical',
        SCHEDULE_SECTION_CONFIG_PINNED: 'scheduleSectionConfigPinned',
        SCHEDULE_SECTION_CONFIG_VERTICAL: 'scheduleSectionConfigVertical',
        SCHEDULE_SECTION_CONFIG_VISIBLE: 'scheduleSectionConfigVisible',
        SCHEDULE_SECTION_FILTERS_PINNED: 'scheduleSectionFiltersPinned',
        SCHEDULE_SECTION_FILTERS_VERTICAL: 'scheduleSectionFiltersVertical',
        SCHEDULE_SECTION_FILTERS_VISIBLE: 'scheduleSectionFiltersVisible',
        SCHEDULE_SECTION_SCHEMES_PINNED: 'scheduleSectionSchemesPinned',
        SCHEDULE_SECTION_SCHEMES_VERTICAL: 'scheduleSectionSchemesVertical',
        SCHEDULE_SECTION_SCHEMES_VISIBLE: 'scheduleSectionSchemesVisible',
        SCHEDULE_VIEW: 'scheduleView',
        SCHEDULE_ZOOM: 'scheduleZoom'
    };

    public static get = (key: string): string => {
        if (!key || !document.cookie) return '';

        const cookie = document.cookie.split(';').find((row) => row.trim().startsWith(key + '='));

        if (!cookie) return '';

        return cookie.split('=')[1];
    };

    public static set = (key: string, value: string): void => {
        document.cookie = `${key}=${value}; path=/; max-age=31536000; SameSite=Strict`;
    };
}
